export const PROJECTION_TYPES = {
  MERCATOR: 0,
  ALBERS_USA: 1
}

export const REGIONS = {
  NC: 'nc',
  US: 'us',
  GLOBAL: 'global'
}

export const REGION_LEVELS = {
  COUNTY: 'county',
  ZIP: 'zip'
}

export const SCALE_TYPES = {
  SYMLOG: 'symlog',
  QUANTIZE: 'quantize',
  DIVERGING: 'diverging',
  DIVERGING_SYMLOG: 'divergingSymlog'
}
